// Function to create a delay with a timeout handle
export function delay(ms: number) {
  let timeoutId: NodeJS.Timeout | undefined;
  const promise = new Promise<void>((resolve) => {
    timeoutId = setTimeout(resolve, ms);
  });

  return { promise, timeoutId };
}
